import { UserRole } from "../models/UserRole";
import { IUserRole } from "../types/IUserRole";
import Store from "./Store";
import AppStore from "./AppStore";
import { makeObservable, runInAction } from "mobx";

export default class UserRoleStore extends Store<IUserRole, UserRole> {
  items = new Map<string, UserRole>();

  constructor(store: AppStore) {
    super(store);
    makeObservable(this, {
      items: true,
      selected: true,
    });
    this.store = store;
  }

  load(items: IUserRole[] = []) {
    runInAction(() => {
      items.forEach((item) =>
        this.items.set(item.id, new UserRole(this.store, item))
      );
    });
  }
}
